// Module
var code = "<svg viewBox=\"0 0 515.556 515.556\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <path d=\"M128.885 257.778L386.663 0v128.886L257.774 257.778l128.897 128.886-.008 128.892z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;